/**
 * 前端表格导出 CSV（不引入额外依赖，Excel 可直接打开）
 */
export function exportCsv(filename, headers, rows) {
	let content = '﻿' + headers.map(h => `"${h}"`).join(',') + '\r\n';
	rows.forEach(row => {
		content += row.map(val => {
			if (val === null || val === undefined) {
				val = '';
			}
			return `"${(val + '').replace(/"/g, '""')}"`;
		}).join(',') + '\r\n';
	});
	let blob = new Blob([content], {type: 'text/csv;charset=utf-8;'});
	let link = document.createElement('a');
	link.href = URL.createObjectURL(blob);
	link.download = `${filename}.csv`;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(link.href);
}
